const BaseTracker = require('./base');

class GoogleTracker extends BaseTracker {
    constructor (locator) {
        super();

        this._window = locator.resolve('window');
        this._config = locator.resolve('config');
        this._logger = locator.resolve('logger');

        this._init();
    }

    /**
     * Начальная настройка трекера
     */
    _init () {
        this._registerTracker();

        const key = this._domainConfig(this._config.analytics.google.keys);

        const beacon = this._config.analytics.google.beacon;
        const ga = this._window[beacon];

        ga('create', key, 'auto');
        ga('require', 'displayfeatures');
        ga('set', 'checkProtocolTask', null);
        ga('send', 'pageview');

        this._initPromise = new Promise((res) => {
            ga(res);
        });
    }

    /**
     * Регистрирование события для гугл-аналитики
     *
     * Вызывается из BaseTracker
     *
     * @param {Object} data
     * @param {*} args
     * @private
     */
    _event (data = {}, args) {
        const beacon = this._config.analytics.google.beacon;

        this._window[beacon]('send', 'event', ...args);
    }

    /**
     * Регистрирование показа страницы для гугл-аналитики
     *
     * Вызывается из BaseTracker
     *
     * @param {*} args
     * @private
     */
    _pageview (...args) {
        const beacon = this._config.analytics.google.beacon;

        this._window[beacon]('send', 'pageview', ...args);
    }

    /**
     * Код предоставленный Google для подключения аналитика на страницу.
     *
     * @private
     */
    _registerTracker () {
        const window = this._window;
        const document = this._window.document;

        const url = this._config.analytics.google.url;
        const beacon = this._config.analytics.google.beacon;

        function googleTracker () {
            window[beacon].q = window[beacon].q || [];
            window[beacon].q.push(arguments);
        }

        window['GoogleAnalyticsObject'] = beacon;
        window[beacon] = window[beacon] || googleTracker;

        window[beacon].l = 1 * new Date();

        const script = document.createElement('script');
        script.async = 1;
        script.src = url;

        const firstScriptNode = document.getElementsByTagName('script')[0];
        firstScriptNode.parentNode.insertBefore(script, firstScriptNode);
    }
}

module.exports = GoogleTracker;



// WEBPACK FOOTER //
// ./services/analytics/trackers/google.js